



























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import store from "@/store";
import moment from "moment";
import { Voyage } from "@/types/voyage";
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";
import VesselsClient from "Clients/vessels-client";

const Vessels = getModule(VesselsModule, store);

interface VoyageOption {
  name: string; // formatted date range
  value: string; // voyageName / id string
  startDate: Date;
  endDate: Date;
  raw: Voyage;
}

@Component({})
export default class VoyageSelect extends Vue {
  @Prop({ default: null }) value!: Voyage | null;
  @Prop({ default: true }) label!: boolean;

  menuOpen = false;
  voyages: VoyageOption[] = [];
  loading = false;
  search = "";
  internalSelected: VoyageOption | null = null;

  @Watch("value", { immediate: true })
  onValueChange(v: Voyage | null) {
    if (!v) {
      this.internalSelected = null;
      return;
    }
    const match = this.voyages.find(vo => vo.raw.id === v.id);
    if (match) this.internalSelected = match;
  }

  get vesselId(): number | null {
    return Vessels.currentVessel ? Vessels.currentVessel.id : null;
  }

  get filteredVoyages(): VoyageOption[] {
    if (!this.search) return this.voyages;
    const q = this.search.toLowerCase();
    return this.voyages.filter(v => v.value.toLowerCase().includes(q) || v.name.toLowerCase().includes(q));
  }

  get selectedVoyageLabel(): string {
    if (!this.internalSelected) return "Select Voyage";
    const v = this.internalSelected;
    return `Voyage ${v.value} ${moment.utc(v.startDate).format("D MMM YYYY")} - ${moment.utc(v.endDate).format("D MMM YYYY")}`;
  }

  async fetchVoyages() {
    if (!this.vesselId) return;
    try {
      this.loading = true;
      const list: Voyage[] = await VesselsClient.getVesselVoyages(this.vesselId);

      // Exclude voyages with endDate "0001-01-01T00:00:00"
      const filtered = list.filter(v => v.endDate !== "0001-01-01T00:00:00");

      // Sort by endDate descending (newest first)
      const sorted = [...filtered].sort((a, b) => new Date(b.endDate).getTime() - new Date(a.endDate).getTime());
      this.voyages = sorted.map(v => ({
        name: `${moment.utc(v.startDate).format("D MMM YYYY")} - ${moment.utc(v.endDate).format("D MMM YYYY")}`,
        value: String(v.voyageName),
        startDate: new Date(v.startDate),
        endDate: new Date(v.endDate),
        raw: v,
      }));
      if (this.value) {
        const match = this.voyages.find(vo => vo.raw.id === this.value!.id);
        if (match) this.internalSelected = match;
      }
    } catch (e) {
      console.error("Failed to fetch voyages", e);
    } finally {
      this.loading = false;
    }
  }

  selectVoyage(v: VoyageOption) {
    this.internalSelected = v;
    this.$emit("input", v.raw);
    this.$emit("update:value", v.raw);
    this.menuOpen = false;
  }

  async mounted() {
    await this.fetchVoyages();
  }
}
